<template>
<div class="chapter">
<div class="inner_page">
<p class="titlepage1"><a id="pagei">TankCraft 19</a></p><a id="pagei">
<h1 class="titlepage2">STUG III &amp; IV</h1>
<p class="titlepage3">GERMAN ARMY, WAFFEN-SS AND LUFTWAFFE</p>
<p class="titlepage4">WESTERN FRONT, 1944-1945</p>
<p class="titlepage5">Dennis Oliver</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?371dcf14